module.exports = __webpack_public_path__ + "static/media/trash_red.81714b65.svg";